export const baseUrl = process.env.NODE_ENV === "production" ?
 "/server/backend_functions/" 
 : "http://localhost:3001/server/backend_functions/";

 export const baseUrl2 = process.env.NODE_ENV === "production" ?
 "/server/" 
 : "http://localhost:3001/server/";